<button mat-stroked-button color="primary" (click)="upload()">UPLOAD</button>
<prettyjson [obj]="data"></prettyjson>
<p>{{data.length}}</p>
